import React, { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Form, Button, notification } from 'antd';

import CustomerForm from './CustomerForm';
import { updateCustomer } from './../../services/customerService';
import { nullifyEmptyStrings } from './../../utils/object';

const GeneralInfoTab = ({ customerData }) => {
    const queryClient = useQueryClient();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    
    const handleFinish = () => {
        form.validateFields()
            .then(async (values) => {
                setLoading(true);
                
                // Nullify empty strings
                nullifyEmptyStrings(values);

                const request = {
                    ...values,
                    birthDate: values.birthDate && values.birthDate.format('YYYY-MM-DD'),
                    address: { ...values.address, id: customerData.address.id },
                    active: true
                }

                try {
                    const { data: customer } = await updateCustomer(customerData.id, request);
                    notification.success({ message: 'Clientes', description: 'Se actualizó el cliente.' });

                    // Actualiza cliente en la cache
                    queryClient.setQueryData(['clients'], (oldData) => {
                        if(!oldData) return [customer];
                        const tmp = oldData.filter(c => c.id !== customerData.id);
                        return [...tmp, customer];
                    });
                } finally {
                    setLoading(false);
                }
            })
            .catch(() => { });
    }

    return <>
        <CustomerForm form={form} initialValues={customerData} />
        <Button type="primary" loading={loading} onClick={handleFinish}>Guardar</Button>
    </>
};

export default GeneralInfoTab;